import { useTranslations } from "next-intl";
import { useSubscriptionStatus, useCurrentUser } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

function SubscriptionRecapCurrentPlan() {
  const t = useTranslations("accounts");

  const subscriptionStatus = useSubscriptionStatus();
  const user = useCurrentUser();
  const price = usePrice();

  const planPrice = user?.subscription?.plan_price;
  const insurance = user?.subscription?.insurance;
  const subscriptionPrice = planPrice?.amount_inc_tax + (insurance ? insurance.amount_inc_tax : 0);

  if (
    [subscriptionStatuses.notSubscribed, subscriptionStatuses.canceled].includes(subscriptionStatus)
  )
    return null;

  const displayCurrentPlanPrice = () => {
    const planPriceKey = insurance ? "price_with_insurance" : "price";

    return t.rich(`manage_subscription.plan.${planPriceKey}`, {
      amount: price(subscriptionPrice, { withoutSpace: true }),
      span: (chunks) => <span className="text-dark">{chunks}</span>,
    });
  };

  const displayCurrentPlanName = () => {
    return (
      <span className="text-dark">
        {t.rich("manage_subscription.plan.name.swapable_between_families", {
          count: planPrice.plan.clothes + planPrice.plan.accessories,
        })}
        {planPrice.plan.unlimited &&
          t.rich("manage_subscription.plan.name.unlimited", {
            span: (chunks) => <span className="text-primary font-weight-bold">{chunks}</span>,
          })}
      </span>
    );
  };

  return (
    <div data-testid="manage-subscription-recap-current-plan-section">
      <p className="mb-0 text-gray">
        {displayCurrentPlanPrice()}
        {displayCurrentPlanName()}
      </p>
    </div>
  );
}

export default SubscriptionRecapCurrentPlan;
